export default __webpack_public_path__ + "static/media/georgi.16c847ee.jpg";